import React, { useRef, useContext, useState, useEffect } from 'react';
import 'scss/components/page-components/Layout/Navbar/UserDropDown.scss';
import { Link, useNavigate } from "react-router-dom";
import AppContext from 'js/Contexts/App.js';
import { produce } from 'immer';
import PopoverMenu from 'js/components/ui/PopoverMenu.js';
import generateUserProfilePic from 'js/components/helpers/generateUserProfilePic.js';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useTranslate2 } from 'js/components/helpers/Translate.js';

const UserDropDown = (props) => {
    const navigate = useNavigate();
    const appContext = useContext(AppContext);
    let currentUser = appContext.authService.getCurrentIdentity()?.user;
    const triggerRef = useRef();
    const [selectedAccount, setSelectedAccount] = useState('');
    const [hasMultipleAccounts, setHasMultipleAccounts] = useState(false);
    const { layoutTranslations } = appContext;
    const translate = useTranslate2(layoutTranslations?.translations || {});
    
    useEffect(() => {
        if (currentUser?.managingAccounts && Array.isArray(currentUser.managingAccounts)) {
            
            const currentCompany = appContext.appReducer.getCurrentAccountWithData();

            const multipleAccounts = currentUser.managingAccounts.length >= 2;

            setHasMultipleAccounts(multipleAccounts);
            
            if (currentCompany?.accountId) {
                setSelectedAccount(currentCompany.accountId);
            } else if (currentUser.managingAccounts.length > 0) {
                setSelectedAccount(currentUser.managingAccounts[0].accountId);
            }
        }
    }, [currentUser?.managingAccounts, appContext.appReducer]);

    const closeDropDown = () => {
        appContext.setMainLayoutState(produce(appContext.mainLayoutState, draft => {
            draft.userDropwDownOpen = false;
        }));
    };
    
    const handleAccountChange = (event) => {
        const newSelectedAccountId = event.target.value;
        
        setSelectedAccount(newSelectedAccountId);
        
        setTimeout(() => {
            closeDropDown();
            navigate("/a/ac/" + newSelectedAccountId);
        }, 100);
    };

    return (

        <div className="L_Navbar_UserDropDown">
            <div className="menuTrigger" ref={triggerRef} onClick={() => {
                props.setUserDropDownOpen(!appContext.mainLayoutState.userDropwDownOpen);
            }}>

                <span className='managingAccount'>
                    {
                        currentUser?.managingAccounts && currentUser.managingAccounts.length > 0 ? (
                              <h3>{currentUser?.managingAccounts?.find(account => account.accountId === selectedAccount)?.label || 
                         currentUser?.managingAccounts?.[0]?.label} </h3>
                    ) : (
                        null
                    )
                    }
                    {generateUserProfilePic(currentUser?.firstname, currentUser?.lastname)}
                </span>
            </div>

            {appContext.mainLayoutState.userDropwDownOpen &&
                <PopoverMenu 
                    className="L_Navbar_UserDropDown_Foldout" 
                    open={true} 
                    anchorEl={triggerRef.current} 
                    placement={'bottom-end'}
                    onClose={closeDropDown}
                >
                    <h3>{translate('Navbar.Account')}</h3>
                    <div className="userHeader">
                        {generateUserProfilePic(currentUser?.firstname, currentUser?.lastname)}
                        <div className="userMeta">
                            <div className="name">{currentUser.firstname || currentUser.email}</div>
                            <div className="email">{currentUser.email}</div>
                        </div>
                    </div>
                    <div className="menuList">
                        <div className="menuItem">
                            <Link onClick={() => { props.setUserDropDownOpen(false); }} to="/a/me/security">
                              <img src="/icon/layout/security-icon.svg"  /> {translate('Navbar.AccountSecurity')}
                            </Link>
                        </div>
                        <div className="menuItem">
                            <Link onClick={() => { props.setUserDropDownOpen(false); }} to="/a/me/settings">
                              <img src="/icon/layout/identity-icon.svg"  /> {translate('Navbar.AccountDetails')}
                            </Link>
                        </div>
                    </div>
                    <h3>{translate('Navbar.Organization')}</h3>
                      {hasMultipleAccounts ? (
                        <div className="accountSelector">
                            <FormControl fullWidth>
                                <Select
                                    className="account-select"
                                    value={selectedAccount}
                                    sx={{ zIndex: 8001 }}
                                    onClick={(e) => e.stopPropagation()}
                                      MenuProps={{
                                        sx: {
                                            marginTop: '10px',
                                        }
                                    }}
                                    onChange={(e) => {
                                      handleAccountChange(e);
                                    }}
                                >
                                    {currentUser?.managingAccounts?.map((account) => (
                                        <MenuItem 
                                            key={account.accountId} 
                                            value={account.accountId}
                                        >
                                            {account.label || account.accountLabel}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    ) : currentUser?.managingAccounts?.length === 1 ? (
                        <div className="accountSelector">
                            <div className="single-account">
                                <div className="single-account-display">
                                    {currentUser.managingAccounts[0].label || currentUser.managingAccounts[0].accountLabel}
                                </div>
                            </div>
                        </div>
                    ) : null}
                    <Link to="/a/create-company-account" onClick={() => { props.setUserDropDownOpen(false); }} className="createAccountLink">
                         <img src="/icon/layout/plus-circle.svg" /> {translate('Navbar.AddNewOrganization')}
                    </Link>
                     <div className="menuList">
                        <div className="menuItem">
                            <Link to={"/a/ac/" + selectedAccount + "/managers"} onClick={() => { props.setUserDropDownOpen(false); }} className="viewAllUsersLink">
                         <img src="/icon/layout/three-people-icon.svg"  /> {translate('Navbar.ManageAllUsersFor')} {currentUser?.managingAccounts?.find(account => account.accountId === selectedAccount)?.label}
                    </Link>
                        </div>

                      <div className="menuItem logout">
                            <a href="#" onClick={(e) => {
                                e.preventDefault();
                                appContext.authService.logoutCurrentUser();
                                navigate('/a/login');
                                props.setUserDropDownOpen(false);
                            }}>
                             <img src="/icon/layout/logout.svg" alt="Logout" /> { translate('Navbar.Logout')}
                            </a>
                        </div>
                    </div>
                   
                     
                     
                </PopoverMenu>
            }
            
        </div>
    );
}

export default UserDropDown;
